import { render, staticRenderFns } from "./MediaPedigree.vue?vue&type=template&id=d4ed591e&scoped=true&"
import script from "./MediaPedigree.vue?vue&type=script&lang=js&"
export * from "./MediaPedigree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed591e",
  null
  
)

export default component.exports